import { sessionManager } from '../utils/sessionUtils';

// Simple analytics service for tracking events with session support
class AnalyticsService {
  async trackEvent(eventName: string, eventData: Record<string, unknown> = {}): Promise<void> {
    try {
      const sessionId = sessionManager.getSessionId();
      
      const enrichedEventData = {
        ...eventData,
        sessionId,
        timestamp: new Date().toISOString(),
        page_url: window.location.href,
        user_agent: navigator.userAgent,
      };

      await fetch('/api/analytics/track', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          eventName, 
          eventData: enrichedEventData 
        }),
      });
    } catch (error) {
      console.warn(`[ANALYTICS] Failed to track ${eventName}:`, error);
    }
  }
}

export const analyticsService = new AnalyticsService();
